
        var result = require("!!../../../../node_modules/css-loader/index.js!./member-perks-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/member-perks-list/member-perks-list.component.css
// module id = 614
// module chunks = 0